import type { AvailabilityConflict } from '@/shared/api';

/** Eingaben der manuellen Buchung außer Apartment und Zeitraum. */
export interface GuestFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  adults: number;
  children: number;
  infants: number;
  nightlyRate: string;
  notes: string;
}

export const EMPTY_GUEST: GuestFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  adults: 2,
  children: 0,
  infants: 0,
  nightlyRate: '',
  notes: '',
};

export function guestFieldsComplete(guest: GuestFormValues, rate: number): boolean {
  return (
    guest.firstName.trim().length > 0 &&
    guest.lastName.trim().length > 0 &&
    guest.email.trim().length > 0 &&
    guest.adults >= 1 &&
    rate >= 0 &&
    guest.nightlyRate.trim().length > 0
  );
}

/**
 * Wann eine manuelle Buchung angelegt werden darf.
 *
 * <p>Unbekannte Verfügbarkeit sperrt, statt freizugeben: schlägt die Abfrage fehl, sind beide
 * Konfliktlisten leer, und ein reiner `length === 0`-Test hielte das für „alles frei". Der Server
 * fängt zwar Überschneidungen ab, aber die weichen Konflikte (Mindestaufenthalt, gesperrte An-
 * und Abreise) existieren nur in dieser Vorwarnung — sie würden lautlos verschwinden.</p>
 */
export function canSubmitManualBooking(input: {
  datesValid: boolean;
  guest: GuestFormValues;
  rate: number;
  availabilityUnknown: boolean;
  hardConflicts: AvailabilityConflict[];
  softConflicts: AvailabilityConflict[];
  override: boolean;
}): boolean {
  const blockedBySoft = input.softConflicts.length > 0 && !input.override;
  return (
    input.datesValid &&
    guestFieldsComplete(input.guest, input.rate) &&
    !input.availabilityUnknown &&
    input.hardConflicts.length === 0 &&
    !blockedBySoft
  );
}
